module.exports = VueRouter;


//////////////////
// WEBPACK FOOTER
// external "VueRouter"
// module id = pRNm
// module chunks = 107